import { Lightning, Utils } from '@lightningjs/sdk';

export class Spinner extends Lightning.Component {
  static _template() {
    return {
      src: Utils.asset('images/spinner.png'),
    };
  }

  _construct() {
    this._animation = this.animation({
      duration: 0.8,
      repeat: -1,
      actions: [{ p: 'rotation', v: { sm: 0, 0: 0, 1: Math.PI * 2 } }],
    });
  }

  _active() {
    this._animation.start();
  }

  _inactive() {
    this._animation.stop();
  }
}
